import { useLocale } from "next-intl";
import { useQuery } from "@tanstack/react-query";

import { getBettingSelectionsSuspensions } from "@/api/bettingSelections";
import { BettingSelectionsQueryKeys } from "./bettingSelectionsQueryKeys";

export const useBettingSelectionsSuspensions = (
  bettingMarketId?: number,
  targetUsername?: string
) => {
  const lang = useLocale();

  return useQuery({
    queryKey: [BettingSelectionsQueryKeys.BettingSelectionsSuspensions, bettingMarketId, targetUsername],
    queryFn: ({ signal }) =>
      getBettingSelectionsSuspensions({ signal, params: { lang, targetUsername, bettingMarketId } }),
    enabled: !!bettingMarketId,
  });
};
